import { inject, injectable } from "inversify";
import { CPLResumableProcessClient, UserResumableProcessType } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IResumableProcessService {
  retrieveResumableProcessByType(type: UserResumableProcessType): Promise<string | undefined>;
  saveResumableProcess(type: UserResumableProcessType, data: string): Promise<void>;
}

@injectable()
export class ResumableProcessService implements IResumableProcessService {
  @inject(SERVICE_TYPES.CPLResumableProcessClient)
  resumableProcessClient!: CPLResumableProcessClient;

  async retrieveResumableProcessByType(type: UserResumableProcessType): Promise<string | undefined> {
    const processID = await this.resumableProcessClient.checkForResumableProcess(type);
    if (processID) {
      return (await this.resumableProcessClient.retrieveResumableProcessByID(processID)).data!;
    } else return undefined;
  }

  async saveResumableProcess(type: UserResumableProcessType, data: string): Promise<void> {
    return this.resumableProcessClient.saveResumableProcess(type, data);
  }
}
